// React components
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';

// Custom components
import AccountProfile from './Profile/Profile';
import Admin from './Admin/Admin';
import { useAuth } from '../../Contexts/AuthContext';
import { useSimulation } from '../../Contexts/SimulationContext';
import Navigation from '../../Components/Navigation/navigation';
import SimulationBanner from '../../Components/SimulationBanner/SimulationBanner';

import { userTypes } from '../../Helpers/utils';
import './account.scss';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Account = () => {

  const auth = useAuth();
  const simulation = useSimulation();

  const {
    activeUser
  } = auth;

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Use effective role for tab visibility
  const effectiveRole = simulation.getEffectiveRole();
  const showAdminTab = effectiveRole === 0 || effectiveRole === 1;

  return (
    <Box 
      sx={{
        display: 'flex',
        width: '100%',
      }}
    >
      <Navigation title={'Account Dashboard'} />
      <Box 
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          padding: '50px',
          paddingTop: '85px',
          paddingBottom: 0,
        }}
      >
        <SimulationBanner />
        <Box
          sx={{
            padding: '20px 0',
          }}
        >
          <Typography 
            align='left'
            component={'h2'}
            sx={{
              fontSize: '1.5rem'
            }}
          >
            {activeUser.firstName} {activeUser.lastName}
          </Typography>
          <Typography
            align='left'
            sx={{
              // color: '#979797'
            }}
          >
            {activeUser.organization.name}
          </Typography>
          <Typography
            align='left'
            sx={{
              color: '#979797'
            }}
          >
            {userTypes(effectiveRole)}
          </Typography>
        </Box>
        <Tabs value={value} onChange={handleChange} aria-label="Account options">
          <Tab 
            label="Profile" 
            sx={{
              paddingLeft: '0',
            }}
            {...a11yProps(0)}
          />
          {showAdminTab &&
            <Tab label="User Admin" {...a11yProps(1)} />
          }
        </Tabs>
        <TabPanel component={'div'} value={value} index={0}>
          <AccountProfile />
        </TabPanel>
        {showAdminTab &&
          <TabPanel value={value} index={1}>
            <Admin />
          </TabPanel>
        }
      </Box>
    </Box>
  );
};

export default Account;